/**
 * For more information about navigation mutation please read description of HistoryStack
 */
export default {
  namespaced: true,
  state: {
    /**
     * Keeps information about currently displayed category:
     * {
     *   category - category object received via SpinnakerApi
     *   isPromo - flag determining if category was opened by clicking on promo carousel
     * }
     */
    activeCategory: undefined,
    /**
     * Determines whether app can display back button or not
     */
    goBackAllowed: false,
    /**
     * Informs whether user is currently scrolling the page or not
     */
    isScrollOngoing: false
  },
  mutations: {
    /**
     * Allows to change back button visibility
     */
    goBackAllowed (state, goBackAllowed) {
      state.goBackAllowed = goBackAllowed
    },
    /**
     * Triggers "previous" view to be displayed. Emulates browser back button click.
     */
    goBack () {},
    /**
     * Redirects to HOME screen. Reopens app.
     */
    goToHome () {},
    /**
     * Changes currently displayed category.
     */
    goToCategory (state, category) {
      state.activeCategory = { category: category }
    },
    /**
     * Changes currently displayed category. As opposed to 'goToCategory' mutation it marks
     * category as opened from promo carousel (make a huge difference in "previous" view).
     */
    goToPromotedCategory (state, category) {
      state.activeCategory = { category: category, isPromo: true }
    },
    /**
     * Locks current view.
     */
    lock () {},
    /**
     * Unlocks currently locked view.
     */
    unlock () {},
    /**
     * Allows to change flag informing about ongoing scroll
     */
    isScrollOngoing (state, isScrollOngoing) {
      state.isScrollOngoing = isScrollOngoing
    }
  }
}
